
import React, { FC } from 'react';
import Color from 'color';
import { darken } from 'polished';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import { useTheme, withTheme } from '@emotion/react';
import styled from '@emotion/styled';



interface ContactButtonProps extends React.HTMLAttributes<HTMLDivElement> {
    icon: "phone" | "comment-alt-lines", show?: boolean
}

/** shows a Contact button for SMS or Phone, if phone not empty */
export const CampaingContactButton: FC<ContactButtonProps> = ({ icon, show = true, ...props }) => {

    const { accent, } = useTheme()

    return show === false ?
        null :
        <ButtonWrapper {...props}>
            <FontAwesome
                icon={icon}
                weight="regular"
                style={{
                    color: Color(accent).isLight() ? '#474747' : '#EFEFEF'
                }}
            />
        </ButtonWrapper >
}


const ButtonWrapper = withTheme(styled.div`
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.accent};
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    cursor: pointer;       
    &:hover,
    &:focus {
        background-color: ${({ theme }) => darken(0.02, theme.accent)};
    }
`)